import clsx from 'clsx';

export const Button = ({ inverted, disabled, isLoading, small, ...props }) => {
  return (
    <div
      className={clsx(
        'relative font-medium',
        disabled || isLoading ? 'cursor-default' : 'cursor-pointer',
      )}
    >
      <button
        className={clsx(
          'flex min-w-40 cursor-pointer items-center justify-center gap-4 rounded-lg border-2 text-lg shadow transition-all',
          small ? 'px-4 py-2' : 'px-6 py-4',
          inverted
            ? 'border-cyan-500 bg-white text-cyan-500 hover:bg-cyan-50'
            : 'border-cyan-500 bg-cyan-500 text-white hover:bg-cyan-600',
          disabled || isLoading ? 'pointer-events-none opacity-50' : 'opacity-100',
        )}
        {...props}
      />
    </div>
  );
};
